import { deleteRequest, get, patch } from './apiClient';

export interface Notification {
  _id: string;
  type: string;
  title: string;
  message: string;
  link: string | null;
  metadata: Record<string, unknown>;
  readBy: string[];
  isRead: boolean;
  /** When this user first read it; null while unread (or read before read times were kept). */
  readAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  /** Pass as `before` for the next (older) page; null when this was the last one. */
  nextCursor: string | null;
  /** How long a read notification stays in the bell (server-owned). */
  readVisibleForMs: number;
}

export async function fetchNotifications(
  { limit = 30, before }: { limit?: number; before?: string | null } = {}
): Promise<NotificationsResponse> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (before) params.set('before', before);
  const res = await get<{ success: boolean; data: NotificationsResponse }>(
    `/notifications?${params.toString()}`
  );
  return res.data;
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await get<{ success: boolean; data: { count: number } }>(
    '/notifications/unread-count'
  );
  return res.data.count;
}

export async function markNotificationAsRead(id: string): Promise<void> {
  await patch(`/notifications/${id}/read`, {});
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await patch('/notifications/read-all', {});
}

/** Removes it from this user's bell only; the feed is shared. */
export async function deleteNotification(id: string): Promise<void> {
  await deleteRequest(`/notifications/${id}`);
}
